"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _applicationList = _interopRequireDefault(require("../shared-components/application-list"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "You do not have access to this page");
var _ref2 = /*#__PURE__*/_react.default.createElement("p", null, "There are no calendar applications yet");
class YearBook extends _react.Component {
  render() {
    if (!this.props.userIsCalendarOfficer) return _ref;
    if (!this.props.calendar || !this.props.calendar.applications || !this.props.calendar.applications.length) return _ref2;
    return /*#__PURE__*/_react.default.createElement(_applicationList.default, {
      applications: this.props.calendar.applications,
      userIsCalendarOfficer: this.props.userIsCalendarOfficer,
      userIsSystemAdmin: this.props.userIsSystemAdmin
    });
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref3 = {
  id: true,
  applications: _mergeBqlQueries({
    id: true
  }, _applicationList.default.partialQueries.Application)
};
var _default = exports.default = (0, _reactBicycle.connect)(YearBook, props => ({
  userIsCalendarOfficer: true,
  userIsSystemAdmin: true,
  ["calendar(yearID:" + JSON.stringify(+props.match.params.yearID) + ")"]: _ref3
}));